import { Box, IconButton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Link } from 'react-router-dom';
import { useMobile } from 'shared/domains/common-ui';
import plogo from './plogo.png';
import { useMobileNavigation } from '../../PageLayout/components/MobileNavigation';
import { useSidebarMenu } from '../useSidebarMenu';
import { Plogo, SidebarMenuHeaderContainer, StyledLogotype, ToggleButton } from './styled';
export function SidebarMenuHeader(props) {
    const { children } = props;
    const { minimized } = useSidebarMenu();
    const { open, close, isOpen } = useMobileNavigation();
    const isMobile = useMobile();
    return (<SidebarMenuHeaderContainer>
      <Box alignItems="center">
        <ToggleButton as={Link} to="/dashboard">
          {minimized ? <Plogo src={plogo} alt="pocketlaw"/> : <StyledLogotype />}
        </ToggleButton>

        {isMobile && (<Box ml="auto">
            <IconButton $round type="button" appearance="ghost" size="small" onClick={isOpen ? close : open}>
              <Falcon icon="sidebar"/>
            </IconButton>
          </Box>)}
      </Box>
      {children}
    </SidebarMenuHeaderContainer>);
}
